import type { TFunction } from 'i18next';

import { uniqueOptions, type FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import { WebhookEndpointStatus, type WebhookEndpoint } from '@nucleus-commerce/api-client/admin';

/**
 * Filters of the endpoints table; `t` is the `webhooks` namespace. Event options are the
 * subscriptions of the loaded endpoints, patterns (`order.*`) included as written.
 */
export function endpointFilters(
  t: TFunction,
  endpoints: readonly WebhookEndpoint[],
): Array<FilterDef<WebhookEndpoint>> {
  return [
    {
      key: 'status',
      label: t('columns.status'),
      type: 'enum',
      pinned: true,
      options: Object.values(WebhookEndpointStatus).map((status) => ({
        value: status,
        label: t(`status.${status}`),
      })),
    },
    {
      key: 'event',
      label: t('columns.event'),
      type: 'enum',
      pinned: true,
      getValue: (row) => row.events,
      options: uniqueOptions(endpoints, (endpoint) => endpoint.events),
    },
  ];
}
